var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import BrokeragePlan from "./BrokeragePlan";
import BrokerageVolume from "./BrokerageVolume";
import BrokingAccountDetails from "./BrokingAccountDetails";
import PayInDetails from "./PayInDetails";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "../../../../../../shared-library/components/Loader";
var BrokingOverview = function () {
    var _a = __read(useState(), 2), brokVolData = _a[0], setBrokVolData = _a[1];
    var _b = __read(useState(), 2), brokVolPlan = _b[0], setBrokVolPlan = _b[1];
    var _c = __read(useState(), 2), brokAccountData = _c[0], setBrokAccountData = _c[1];
    var _d = __read(useState(false), 2), loader = _d[0], setLoader = _d[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    function getBrokingAccountDetails() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoader(true);
                        _a = setBrokAccountData;
                        return [4 /*yield*/, di.clients.getBrokingAccountDetails({
                                acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                            })];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        setLoader(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getBrokingVolume() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoader(true);
                        _a = setBrokVolData;
                        return [4 /*yield*/, di.clients.getBrokVolumeDetails({
                                acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                            })];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        setLoader(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getBrokingPlan() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoader(true);
                        _a = setBrokVolPlan;
                        return [4 /*yield*/, di.clients.getBrokingPlanDetails({
                                acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                            })];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        setLoader(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    React.useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode) {
            getBrokingAccountDetails();
            getBrokingVolume();
            getBrokingPlan();
        }
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode]);
    return (React.createElement(React.Fragment, null, loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement(BrokingAccountDetails, { cashAcc: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.cash, stockAssest: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.stock, marginAvailable: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.margin, AbdPlan: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.adbPlan, AbdAmount: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.adbAmount, expirydate: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.expiryDate, AbdConsumed: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.adBConsumed, shortfall: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.shortFall, Ageing: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.age, DelayedPaymentCharges: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.dpc, smtF_INTEREST: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.smtF_Interest, smtF_DPC_Rate: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.smtF_DPC_Rate, fnO_DPC_Rate: brokAccountData === null || brokAccountData === void 0 ? void 0 : brokAccountData.fnO_DPC_Rate }),
        React.createElement(BrokerageVolume, { data: brokVolData }),
        React.createElement(BrokeragePlan, { data: brokVolPlan }),
        React.createElement(PayInDetails, null)))));
};
export default BrokingOverview;
